import axiosInstance from "./api_helper";

const unwrap = (response) => response.data?.body ?? response.data;

const userService = {
    search: async (query = "") => {
        const response = await axiosInstance.get("/users", {
            params: { query },
        });
        return unwrap(response);
    },

    create: async (payload) => {
        const response = await axiosInstance.post("/users", JSON.stringify(payload));
        return unwrap(response);
    },

    update: async (id, payload) => {
        const response = await axiosInstance.put(`/users/${id}`, JSON.stringify(payload));
        return unwrap(response);
    },

    setEnabled: async (id, enabled) => {
        const response = await axiosInstance.patch(`/users/${id}/enabled`, JSON.stringify({ enabled }));
        return unwrap(response);
    },
};

export default userService;
